import { Navigate, useNavigate, useParams } from 'react-router';
import { routes } from '~/routes';
import { LocationDetailPage } from './LocationDetailPage';

/** `/locations/:officeId`: one location of a multi-location account, with a way back to the list. */
export const LocationDetailRoute = () => {
  const { officeId } = useParams();
  const navigate = useNavigate();

  if (!officeId) return <Navigate to={routes.locations} replace />;

  return <LocationDetailPage officeId={officeId} onBack={() => navigate(routes.locations)} />;
};
